export enum ModalType {
  Delete = 1,
  Update = 2,
  Add = 3,
  Reactivate = 4
}

export enum PromotionOption {
  Worklist = 'worklist',
  Mine = 'mine',
  All = 'all'
}

export class EnumItem {
  public id = 0
  public name = ''
}

export type EnumDictionary<T extends string | symbol | number, U> = {
  [K in T]: U
}
